/**
 * W01 — BDT currency formatting (framework-free, domain layer).
 * English locale renders `৳ 12,500`; Bengali locale renders Bengali numerals `৳ ১২,৫০০`.
 * NaN / non-finite input degrades to `৳ 0` instead of throwing or rendering "NaN".
 */
export type SupportedLocale = 'en' | 'bn';

const BN_DIGITS = ['০', '১', '২', '৩', '৪', '৫', '৬', '৭', '৮', '৯'];

export function toBengaliNumerals(value: string): string {
  return value.replace(/[0-9]/g, (d) => BN_DIGITS[Number(d)]);
}

export function formatBDT(amount: number, locale: SupportedLocale = 'en'): string {
  const safe = Number.isFinite(amount) ? amount : 0;
  const sign = safe < 0 ? '-' : '';
  const abs = Math.abs(safe);
  const hasCents = Math.abs(abs % 1) > 1e-9;
  const formatted = abs.toLocaleString('en-US', {
    minimumFractionDigits: hasCents ? 2 : 0,
    maximumFractionDigits: 2,
  });
  const body = `${sign}৳ ${formatted}`;
  return locale === 'bn' ? toBengaliNumerals(body) : body;
}
